import React from "react";
import { Button } from "@material-ui/core";
import { ShowChart } from "@material-ui/icons";

export default function StreamflowDataButton({ feature, flowLocationIds }) {
  const locationId = feature?.properties?.locationid;

  if (!flowLocationIds || !flowLocationIds.has(locationId)) {
    return null;
  }

  const handleClick = () => {
    const url = new URL(window.location);
    url.searchParams.set("streamflow_loc", locationId);
    url.searchParams.set("streamflow_param", "2");
    window.history.pushState({}, "", url);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      startIcon={<ShowChart />}
      onClick={handleClick}
      style={{ marginTop: 8, width: "100%" }}
    >
      View Streamflow Data
    </Button>
  );
}
